export const customerLinks = [
  {to:"/my-account",label:"My account",end:true},
  {to:"/my-account?tab=orders",label:"My orders"},
  {to:"/my-account?tab=appointments",label:"My appointments"},
  {to:"/pharmacies",label:"Find pharmacies"},
  {to:"/clinics",label:"Book an appointment"},
  {to:"/my-profile",label:"My profile"},
];
